import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dateFormat from "dateformat";
import { toast } from "react-toastify";
import { fetchApplicationLists } from "../../utilities/dashboardServices";
import moment from 'moment-timezone';

export const fetchAppListsCPR = createAsyncThunk(
  "fetchAppListsCPR",
  fetchApplicationLists
);

export const fetchAppListsFAF = createAsyncThunk(
  "fetchAppListsFAF",
  fetchApplicationLists
);

export const fetchFilterAppListsCPR = createAsyncThunk(
  "fetchFilterAppListsCPR",
  fetchApplicationLists
);

export const fetchFilterAppListsFAF = createAsyncThunk(
  "fetchFilterAppListsFAF",
  fetchApplicationLists
);

const initialState = {
  applicationList: [],
  renderFlage: false,
  loader: false,
  allApplicationList: [],
  applicationUpdateflage: false,
  valueCPR: [
    {
      program: "--",
      ApplicationID: "--",
      PatientFullName: "--",
      PortalAppStatus: "--",
      PatientBalance: "--",
      awardAmount: "0",
      FundName: "--",
      AwardYear: '--',
      AppLookBackDate: "--",
      AppApprovalDateTime: "--",
      AppExpirationDate: "--",
      pxCreateDateTime: "",
      IncomeProof: "false",
      AppStatusReason: "",
      FundGroup: "",
      FundID: "",
      DiagnosisVerification: 'false',
      IsEligibleForClaim: "false",
      IsEligibleForDoc: "false",
      IsEligibleForReapply: "false",
      IsExpiredLastMonth: "false",
      IsExpiredLastWeek: "false",
      IsExpiryInWeek: "false",
      IsLookBackAvailable: "",
      IsPDMICardGenerated: "false",
      IsPEXAvailable: "false",
      IsPEXEnrolled: "false",
      IsRenewal: "false",
      IsRevokedInWeek: "false",
      IsRevokedToday: "false",
      IVAuditFlag: "true",
      NoClaim: "false",
      PatientBalance: "0",
      awardAmount: "0",
      patientBalance: "--",
      PatientDOB: "",
      PatientID: "",
      PatientSSN: "",
      PatientAlienNumber: '',
      ProgramID: "",
      pxCreateDateTime: "--",
      unGuaranteedAmount: "--",
      guaranteedAmount: "--",
      appGracePeriod: "--",
      DisplayName: '--',
      revokeDate: "--"
    },
  ],
  valueFAF: [
    {
      program: "--",
      ApplicationID: "--",
      PatientFullName: "--",
      PortalAppStatus: "--",
      PatientBalance: "--",
      awardAmount: "0",
      FundName: "--",
      AwardYear: '--',
      AppLookBackDate: "--",
      AppApprovalDateTime: "--",
      AppExpirationDate: "--",
      pxCreateDateTime: "",
      IncomeProof: "false",
      AppStatusReason: "",
      FundGroup: "",
      FundID: "",
      DiagnosisVerification: 'false',
      IsEligibleForClaim: "false",
      IsEligibleForDoc: "false",
      IsEligibleForReapply: "false",
      IsExpiredLastMonth: "false",
      IsExpiredLastWeek: "false",
      IsExpiryInWeek: "false",
      IsLookBackAvailable: "",
      IsPDMICardGenerated: "false",
      IsPEXAvailable: "false",
      IsPEXEnrolled: "false",
      IsRenewal: "false",
      IsRevokedInWeek: "false",
      IsRevokedToday: "false",
      IVAuditFlag: "true",
      NoClaim: "false",
      PatientBalance: "0",
      awardAmount: "0",
      patientBalance: "--",
      PatientDOB: "",
      PatientID: "",
      PatientSSN: "",
      PatientAlienNumber: '',
      ProgramID: "",
      pxCreateDateTime: "",
      DisplayName: '--',
    },
  ]
};

const applicationsSlice = createSlice({
  name: "applications",
  initialState,
  reducers: {
    resetApplicationsLists: (state) => {
      state.valueCPR = [
        {
          program: "--",
          ApplicationID: "--",
          PatientFullName: "--",
          PortalAppStatus: "--",
          PatientBalance: "--",
          FundName: "--",
          AwardYear: '--',
          AppLookBackDate: "--",
          AppApprovalDateTime: "--",
          AppExpirationDate: "--",
          pxCreateDateTime: "",
          IncomeProof: "false",
          AppStatusReason: "",
          FundGroup: "",
          FundID: "",
          DiagnosisVerification: 'false',
          IsEligibleForClaim: "false",
          IsEligibleForDoc: "false",
          IsEligibleForReapply: "false",
          IsExpiredLastMonth: "false",
          IsExpiredLastWeek: "false",
          IsExpiryInWeek: "false",
          IsLookBackAvailable: "",
          IsPDMICardGenerated: "false",
          IsPEXAvailable: "false",
          IsPEXEnrolled: "false",
          IsRenewal: "false",
          IsRevokedInWeek: "false",
          IsRevokedToday: "false",
          IVAuditFlag: "true",
          NoClaim: "false",
          PatientBalance: "0",
          awardAmount: "0",
          patientBalance: "--",
          PatientDOB: "",
          PatientID: "",
          PatientSSN: "",
          PatientAlienNumber: '',
          ProgramID: "",
          pxCreateDateTime: "",
          DisplayName: '--',
          unGuaranteedAmount: "--",
          guaranteedAmount: "--",
          appGracePeriod: "--",
          revokeDate: "--"
        },
      ];
      state.valueFAF = [
        {
          program: "--",
          ApplicationID: "--",
          PatientFullName: "--",
          PortalAppStatus: "--",
          PatientBalance: "--",
          FundName: "--",
          AwardYear: '--',
          AppLookBackDate: "--",
          AppApprovalDateTime: "--",
          AppExpirationDate: "--",
          pxCreateDateTime: "",
          IncomeProof: "false",
          AppStatusReason: "",
          FundGroup: "",
          FundID: "",
          DiagnosisVerification: 'false',
          IsEligibleForClaim: "false",
          IsEligibleForDoc: "false",
          IsEligibleForReapply: "false",
          IsExpiredLastMonth: "false",
          IsExpiredLastWeek: "false",
          IsExpiryInWeek: "false",
          IsLookBackAvailable: "",
          IsPDMICardGenerated: "false",
          IsPEXAvailable: "false",
          IsPEXEnrolled: "false",
          IsRenewal: "false",
          IsRevokedInWeek: "false",
          IsRevokedToday: "false",
          IVAuditFlag: "true",
          NoClaim: "false",
          PatientBalance: "0",
          awardAmount: "0",
          patientBalance: "--",
          PatientDOB: "",
          PatientID: "",
          PatientSSN: "",
          PatientAlienNumber: '',
          ProgramID: "",
          pxCreateDateTime: "",
          DisplayName: ''
        },
      ];
      state.allApplicationList = []

      // toast.success("Applictions reseted Successfully")
    },
    setApplicationList: (state) => {
    },
    resetApplicationUpdateflage: (state, action) => {
      state.applicationUpdateflage = action.payload
    },
    allApplicationList: (state, action) => {
      state.allApplicationList = action.payload

    },
    restRenderFlage: (state, action) => {
      state.renderFlage = action.payload

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppListsCPR.pending, (state, action) => {
        // toast.warn("applications list pending")
        state.loader = true;
      })
      .addCase(fetchAppListsCPR.fulfilled, (state, action) => {
        state.loader = false;
        let arr = [];
        action.payload.res.length > 0 &&
          action.payload.res.map((data) => {
            var year = data?.PatientDOB.substring(0, 4);
            var month = data?.PatientDOB.substring(4, 6);
            var day = data?.PatientDOB.substring(6, 8);

            // Format the date as mm/dd/yyyy
            var formattedDate = month + '/' + day + '/' + year;
            let value = {
              program: action.payload.prg,
              ApplicationID: data?.ApplicationID || "--",
              PatientFullName: data?.pxPages?.Member?.pyFullName || data?.PatientFullName || "--",
              PortalAppStatus: data?.PortalAppStatus || "--",
              PatientBalance: data?.PatientBalance || "--",
              awardAmount: data?.AwardAmount == "0" ? "$0.00" : `$${Number(data?.AwardAmount).toFixed(2)}`,
              patientBalance: data?.PatientBalance ? (data?.PatientBalance == "0" ? "$0.00" : `$${Number(data?.PatientBalance).toFixed(2)}`) : "--",
              unGuaranteedAmount: data?.UnGuaranteedAmount == "0" ? "$0.00" : `$${Number(data?.UnGuaranteedAmount).toFixed(2)}`,
              guaranteedAmount: data?.GuaranteedAmount == "0" ? "$0.00" : `$${Number(data?.GuaranteedAmount).toFixed(2)}`,
              FundName: data?.FundName || "--",
              AwardYear: typeof data?.AppApprovalDateTime != 'undefined' && data?.AppApprovalDateTime != '' ? data?.AppApprovalDateTime.substring(0, 4) : '--',
              AppLookBackDate: typeof data?.AppLookBackDate != 'undefined' && data?.AppLookBackDate != '' ? moment(data?.AppLookBackDate).tz('America/New_York').format('ll') : "--",
              AppApprovalDateTime: typeof data?.AppApprovalDateTime != 'undefined' && data?.AppApprovalDateTime != '' ? moment(data?.AppApprovalDateTime).tz('America/New_York').format('ll') : "--",
              AppExpirationDate: typeof data?.AppExpirationDate != 'undefined' && data?.AppExpirationDate != "" ? moment(data?.AppExpirationDate).tz('America/New_York').format('ll') : "--",
              appGracePeriod: typeof data?.AppGracePeriod != 'undefined' && data?.AppGracePeriod != "" ? moment(data?.AppGracePeriod).tz('America/New_York').format('ll') : "--",
              revokeDate: typeof data?.AppResolvedDateTime != 'undefined' && data?.AppResolvedDateTime != "" ? moment(data?.AppResolvedDateTime).tz('America/New_York').format('ll') : "--",
              pxCreateDateTime: data?.pxCreateDateTime || "",
              IncomeProof: data?.IncomeProof,
              AppStatusReason: data?.AppStatusReason,
              FundGroup: data?.FundGroup,
              FundID: data?.FundID,
              DiagnosisVerification: data?.DiagnosisVerification,
              IsEligibleForClaim: data?.IsEligibleForClaim,
              IsEligibleForDoc: data?.IsEligibleForDoc,
              IsEligibleForReapply: data?.IsEligibleForReapply,
              IsExpiredLastMonth: data?.IsExpiredLastMonth,
              IsExpiredLastWeek: data?.IsExpiredLastWeek,
              IsExpiryInWeek: data?.IsExpiryInWeek,
              IsLookBackAvailable: data?.IsLookBackAvailable,
              IsPDMICardGenerated: data?.IsPDMICardGenerated,
              IsPEXAvailable: data?.IsPEXAvailable,
              IsPEXEnrolled: data?.IsPEXEnrolled,
              IsRenewal: data?.IsRenewal,
              IsRevokedInWeek: data?.IsRevokedInWeek,
              IsRevokedToday: data?.IsRevokedToday,
              IVAuditFlag: data?.IVAuditFlag,
              NoClaim: data?.NoClaim,
              PatientBalance: data?.PatientBalance,
              PatientDOB: formattedDate,
              PatientID: data?.PatientID,
              PatientSSN: data?.PatientSSN,
              PatientAlienNumber: data?.PatientAlienNumber,
              ProgramID: data?.ProgramID,
              pxCreateDateTime: data?.pxCreateDateTime,
              DisplayName: data?.DisplayName
            };
            arr.push(value);
          });
        state.valueCPR = arr;
        state.renderFlage = true;
        // toast.success("Applictions Fetched Successfully")
      })
      .addCase(fetchAppListsCPR.rejected, (state, action) => {
        // toast.error(action.error.message)
        state.loader = false;
      })

      .addCase(fetchAppListsFAF.pending, (state, action) => {
        // toast.warn("applications list pending")
        state.loader = true;
      })
      .addCase(fetchAppListsFAF.fulfilled, (state, action) => {
        state.loader = false;
        let arr = [];
        action.payload.res.length > 0 &&
          action.payload.res.map((data) => {
            var year = data?.PatientDOB.substring(0, 4);
            var month = data?.PatientDOB.substring(4, 6);
            var day = data?.PatientDOB.substring(6, 8);

            // Format the date as mm/dd/yyyy
            var formattedDate = month + '/' + day + '/' + year;
            let value = {
              program: action.payload.prg,
              ApplicationID: data?.ApplicationID || "--",
              PatientFullName: data?.pxPages?.Member?.pyFullName || data?.PatientFullName || "--",
              PortalAppStatus: data?.PortalAppStatus || "--",
              PatientBalance: data?.PatientBalance || "--",
              awardAmount: data?.AwardAmount == "0" ? "$0.00" : `$${Number(data?.AwardAmount).toFixed(2)}`,
              patientBalance: data?.PatientBalance ? (data?.PatientBalance == "0" ? "$0.00" : `$${Number(data?.PatientBalance).toFixed(2)}`) : "--",
              FundName: data?.FundName || "--",
              AwardYear: typeof data?.AppApprovalDateTime != 'undefined' && data?.AppApprovalDateTime != '' ? data?.AppApprovalDateTime.substring(0, 4) : '--',
              AppLookBackDate: typeof data?.AppLookBackDate != 'undefined' && data?.AppLookBackDate != '' ? moment(data?.AppLookBackDate).tz('America/New_York').format('ll') : "--",
              AppApprovalDateTime: typeof data?.AppApprovalDateTime != 'undefined' && data?.AppApprovalDateTime != '' ? moment(data?.AppApprovalDateTime).tz('America/New_York').format('ll') : "--",
              AppExpirationDate: typeof data?.AppExpirationDate != 'undefined' && data?.AppExpirationDate != "" ? moment(data?.AppExpirationDate).tz('America/New_York').format('ll') : "--",
              pxCreateDateTime: data?.pxCreateDateTime || "",
              IncomeProof: data?.IncomeProof,
              AppStatusReason: data?.AppStatusReason,
              FundGroup: data?.FundGroup,
              FundID: data?.FundID,
              DiagnosisVerification: data?.DiagnosisVerification,
              IsEligibleForClaim: data?.IsEligibleForClaim,
              IsEligibleForDoc: data?.IsEligibleForDoc,
              IsEligibleForReapply: data?.IsEligibleForReapply,
              IsExpiredLastMonth: data?.IsExpiredLastMonth,
              IsExpiredLastWeek: data?.IsExpiredLastWeek,
              IsExpiryInWeek: data?.IsExpiryInWeek,
              IsLookBackAvailable: data?.IsLookBackAvailable,
              IsPDMICardGenerated: data?.IsPDMICardGenerated,
              IsPEXAvailable: data?.IsPEXAvailable,
              IsPEXEnrolled: data?.IsPEXEnrolled,
              IsRenewal: data?.IsRenewal,
              IsRevokedInWeek: data?.IsRevokedInWeek,
              IsRevokedToday: data?.IsRevokedToday,
              IVAuditFlag: data?.IVAuditFlag,
              NoClaim: data?.NoClaim,
              PatientBalance: data?.PatientBalance,
              PatientDOB: formattedDate,
              PatientID: data?.PatientID,
              PatientSSN: data?.PatientSSN,
              PatientAlienNumber: data?.PatientAlienNumber,
              ProgramID: data?.ProgramID,
              pxCreateDateTime: data?.pxCreateDateTime,
              DisplayName: data?.DisplayName
            };
            arr.push(value);
          });
        state.valueFAF = arr;
        state.renderFlage = true;
        // toast.success("Applictions Fetched Successfully")
      })
      .addCase(fetchAppListsFAF.rejected, (state, action) => {
        // toast.error(action.error.message)
        state.loader = false;
      });
  },
});

export const { resetApplicationsLists, setApplicationList, allApplicationList, resetApplicationUpdateflage, restRenderFlage } =
  applicationsSlice.actions;

export const applists = (state) => state.applicationsSlice.value;
export default applicationsSlice.reducer;
